var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRightArrowLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 8,
    viewBox: "0 0 21 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Arrow 4",
    d: "M20.1454 4.15824C20.3407 3.96298 20.3407 3.6464 20.1454 3.45113L16.9635 0.269154C16.7682 0.0738914 16.4516 0.0738914 16.2564 0.269154C16.0611 0.464416 16.0611 0.780998 16.2564 0.97626L19.0848 3.80469L16.2564 6.63311C16.0611 6.82838 16.0611 7.14496 16.2564 7.34022C16.4516 7.53548 16.7682 7.53548 16.9635 7.34022L20.1454 4.15824ZM0.742188 4.30469H19.7919V3.30469H0.742188V4.30469Z",
    fill: "#007BFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightArrowLight);
export default __webpack_public_path__ + "static/media/right-arrow-light.43aef3c5d6091c74671a5f4ef73ac831.svg";
export { ForwardRef as ReactComponent };